import React, { Component } from 'react';

//componentes
import Contacto from './contacto'

class Index extends Component {

    render(){
        return(
            <div>
                <Contacto />
            </div>
        );
    }

}
export default Index;